import { Typography, Box } from "@mui/material";
import { useThemeColor } from "../../hooks/useThemeColor";

const Header = ({ title, subtitle }) => {
  const { colors } = useThemeColor();

  return (
    <Box mb="30px">
      <Typography
        variant="h3"
        color={colors.grey[100]}
        fontWeight="bold"
        sx={{ m: "0 0 5px 0" }}
      >
        {title}
      </Typography>
      <Typography variant="h5" color={colors.greenAccent[400]}>
        {subtitle}
      </Typography>
    </Box>
  );
};

export default Header;
